import { gsap } from "gsap";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(CustomEase, ScrollTrigger);

if(document.body.classList.contains('page-template-page-events')){

	window.addEventListener('load', function () {

		// SQUIRREL

    gsap.to("#flying-squirrel", {
      xPercent:-100,
      yPercent:25,
      duration:1.15,
      ease: "power1.inOut",
      opacity:1,
      scrollTrigger: {
        trigger: ".events-wrapper",
      },
    });

	});

}